/* Absolute Furniture Warehouse – product page & chrome behaviour */
(function () {
  'use strict';
  if (window.__afwLoaded) return; window.__afwLoaded = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Countdowns (announcement bar + price) ---------- */
  function initCountdowns() {
    var cds = $$('[data-afw-countdown]');
    if (!cds.length) return;
    function tick() {
      var now = Date.now();
      cds.forEach(function (cd) {
        var end = Date.parse(cd.getAttribute('data-end'));
        if (isNaN(end)) { cd.hidden = true; return; }
        var left = Math.max(0, Math.floor((end - now) / 1000));
        if (left === 0) {
          var wrap = cd.closest('[data-afw-hide-when-ended]');
          if (wrap) { wrap.hidden = true; } else { cd.textContent = cd.getAttribute('data-ended-text') || 'Offer ended'; }
          return;
        }
        var set = function (u, v) { var el = cd.querySelector('[data-u="' + u + '"]'); if (el) el.textContent = v; };
        set('d', pad(Math.floor(left / 86400)));
        set('h', pad(Math.floor(left % 86400 / 3600)));
        set('m', pad(Math.floor(left % 3600 / 60)));
        set('s', pad(left % 60));
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Header: mobile menu + search ---------- */
  function initHeader() {
    var menuBtn = $('#afwMenuBtn'), nav = $('#afwNav');
    if (menuBtn && nav) menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
    var sBtn = $('#afwSearchBtn'), sBar = $('#afwSearchBar');
    if (sBtn && sBar) sBtn.addEventListener('click', function () {
      sBar.hidden = !sBar.hidden;
      if (!sBar.hidden) { var i = sBar.querySelector('input'); if (i) i.focus(); }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#afwToast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- Delivery check (mirrors the live postcode-based delivery rates) ---------- */
  var SHIP_ZONES = [
    { name: 'Metro Brisbane', ranges: [[4000, 4016], [4023, 4024], [4026, 4029], [4033, 4033], [4038, 4050], [4052, 4052], [4056, 4058], [4061, 4206]], price: [120, 140, 150] },
    { name: 'Just Out of Metro Brisbane', ranges: [[4017, 4022], [4025, 4025], [4030, 4032], [4034, 4037], [4051, 4051], [4053, 4055], [4059, 4060], [4300, 4342], [4500, 4509]], price: [150, 180, 200] },
    { name: 'Gold Coast', ranges: [[4207, 4230], [4270, 4274], [4276, 4279], [4281, 4284], [4286, 4286]], price: [170, 180, 220] },
    { name: 'Flagstone / Jimboomba', ranges: [[4280, 4280]], price: [170, 180, 220] },
    { name: 'Scenic Rim / Beaudesert', ranges: [[4275, 4275], [4285, 4285], [4287, 4287]], price: [170, 180, 220] },
    { name: 'Caboolture / Moreton Bay', ranges: [[4510, 4510]], price: [200, 220, 250] },
    { name: 'Gympie', ranges: [[4570, 4570]], price: [200, 220, 250] },
    { name: 'Sunshine Coast / Noosa', ranges: [[4511, 4569], [4571, 4575]], price: [200, 220, 250] },
    { name: 'Toowoomba / Darling Downs', ranges: [[4343, 4419], [4421, 4470], [4482, 4482], [4486, 4498], [4614, 4614]], price: [220, 240, 250] },
    { name: 'Wide Bay / Bundaberg / Fraser Coast', ranges: [[4576, 4670]], price: [280, 300, 350], confirm: true },
    { name: 'Gladstone', ranges: [[4680, 4680]], price: [350, 380, 450], confirm: true },
    { name: 'Mackay', ranges: [[4740, 4740]], price: [350, 380, 450], confirm: true },
    { name: 'Rockhampton / Central QLD', ranges: [[4671, 4679], [4681, 4739], [4741, 4749]], price: [350, 380, 450], confirm: true },
    { name: 'Mackay / Whitsundays', ranges: [[4750, 4805]], price: [380, 440, 480], confirm: true },
    { name: 'Townsville / North QLD', ranges: [[4806, 4859]], price: [400, 440, 550], confirm: true },
    { name: 'Cairns / Far North QLD', ranges: [[4860, 4899]], price: [450, 480, 550], confirm: true },
    { name: 'Sydney Inner / East', ranges: [[2000, 2050]], price: [350, 380, 440], confirm: true },
    { name: 'Sydney North', ranges: [[2055, 2055], [2057, 2059], [2060, 2122]], price: [350, 380, 440], confirm: true },
    { name: 'Sydney West', ranges: [[2123, 2189], [2745, 2770]], price: [380, 380, 450], confirm: true },
    { name: 'Sydney South / South West', ranges: [[2190, 2234], [2555, 2570]], price: [350, 380, 440], confirm: true },
    { name: 'Central Coast', ranges: [[2083, 2083], [2250, 2263], [2775, 2775]], price: [350, 380, 440], confirm: true },
    { name: 'Newcastle / Lake Macquarie', ranges: [[2259, 2259], [2264, 2267], [2278, 2308], [2318, 2318], [2322, 2323]], price: [350, 380, 440], confirm: true },
    { name: 'Wollongong / Illawarra', ranges: [[2500, 2530], [2533, 2535], [2560, 2560], [2577, 2577]], price: [380, 440, 480], confirm: true },
    { name: 'Northern NSW / Northern Rivers', ranges: [[2469, 2490]], price: [380, 440, 480], confirm: true },
    { name: 'Mid North Coast', ranges: [[2428, 2468]], price: [380, 440, 480], confirm: true },
    { name: 'Southern Highlands / Shoalhaven', ranges: [[2533, 2541], [2571, 2571], [2575, 2579], [2622, 2622]], price: [380, 440, 480], confirm: true },
    { name: 'ACT / Canberra', ranges: [[200, 299], [2600, 2618], [2620, 2620], [2900, 2906], [2911, 2914]], price: [440, 480, 485], confirm: true },
    { name: 'Victoria', ranges: [[3000, 3010], [3011, 3049], [3050, 3099], [3100, 3156], [3160, 3204], [3205, 3207], [3211, 3251], [3252, 3329], [3330, 3381], [3382, 3439], [3440, 3579], [3580, 3749], [3750, 3764], [3765, 3799], [3800, 3978]], price: [440, 480, 485], confirm: true }
  ];
  function findShipZone(pc) {
    var n = parseInt(pc, 10);
    for (var i = 0; i < SHIP_ZONES.length; i++) {
      var z = SHIP_ZONES[i];
      for (var j = 0; j < z.ranges.length; j++) { if (n >= z.ranges[j][0] && n <= z.ranges[j][1]) return z; }
    }
    return null;
  }
  function stateOfPc(pc) {
    var n = parseInt(pc, 10);
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || n === 2620 || (n >= 2900 && n <= 2920)) return 'ACT';
    return { '0': 'NT', '2': 'NSW', '3': 'VIC', '4': 'QLD', '5': 'SA', '6': 'WA', '7': 'TAS', '9': 'QLD' }[pc.charAt(0)] || '';
  }
  /* Products on the Small / Large delivery profiles; everything else stays on Medium (matches the live delivery setup) */
  var SHIP_SMALL_IDS = ['8928969687324', '8930822979868', '10834945245468', '10834995708188', '10877850353948', '10912352370972', '10915063005468', '10981872468252', '10981888295196'];
  var SHIP_LARGE_IDS = ['9417564848412', '9611215274268', '9731094348060', '10107069038876', '10634771398940', '10634775200028', '10655941755164', '10688984285468', '10873833521436', '10959594651932', '10975422480668', '10980530946332', '10980556439836', '10985553592604', '10986782097692'];
  function shipSizeIndex(productId, loungeSize) {
    var s = String(loungeSize || '').trim().toLowerCase();
    if (s === 'small') return 0;
    if (s === 'large') return 2;
    if (s === 'medium') return 1;
    // Fallback for products without the lounge_size metafield set yet.
    var id = String(productId);
    if (SHIP_SMALL_IDS.indexOf(id) > -1) return 0;
    if (SHIP_LARGE_IDS.indexOf(id) > -1) return 2;
    return 1;
  }
  function shipMoney(n) { return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  var TRUCK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="6" width="15" height="12" rx="1"/><path d="M16 10h3.5l3.5 4v4h-7"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>';
  var SHIELD_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></svg>';
  function initShipbox(root) {
    var box = $('[data-afw-shipbox]', root);
    if (!box) return;
    var dataEl = $('[data-afw-product-json]', root), product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = $('[data-afw-variant-id]', root), qtyInput = $('[data-afw-qty]', root);
    var addons = $$('[data-afw-addon]', root);
    var currency = root.getAttribute('data-currency') || 'AUD';
    var shipboxPreorder = root.getAttribute('data-is-preorder') === 'true';
    function money(cents) { return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: currency }); }
    function curVariant() {
      var id = idInput ? Number(idInput.value) : 0;
      return product ? product.variants.filter(function (v) { return v.id === id; })[0] : null;
    }
    var dateEl = $('[data-afw-fast-date]', box), fastDateText = '';
    if (dateEl) {
      /* Pin to Brisbane time (UTC+10, no DST) so the date is correct regardless of the
         visitor's own device timezone — matches the BNE offset used for countdowns elsewhere. */
      var d = new Date(Date.now() + 10 * 3600 * 1000 + 3 * 86400000);
      /* No deliveries on weekends: if the 3-day target lands on Sat/Sun, push to the following Monday. */
      if (d.getUTCDay() === 6) d.setUTCDate(d.getUTCDate() + 2);
      else if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
      fastDateText = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getUTCMonth()];
      dateEl.textContent = fastDateText;
    }
    var form = $('[data-afw-ship-form]', box), input = $('[data-afw-ship-input]', box);
    var stateSel = $('[data-afw-ship-state]', box), out = $('[data-afw-ship-result]', box);
    if (!form) return;
    /* Assembly can't be delivered to areas outside the 3-day zone: uncheck + lock the
       add-on and show why, the moment a postcode resolves to one of those areas. */
    var asmCheckbox = $('[data-afw-addon-assembly]', root);
    var asmOpt = asmCheckbox ? asmCheckbox.closest('[data-guard-opt]') : null;
    var asmNote = $('[data-afw-asm-note]', root);
    function setAsmRestricted(restricted) {
      if (!asmCheckbox) return;
      if (restricted && asmCheckbox.checked) {
        asmCheckbox.checked = false;
        asmCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      asmCheckbox.disabled = restricted;
      if (asmOpt) asmOpt.classList.toggle('is-disabled', restricted);
      if (asmNote) asmNote.hidden = !restricted;
    }
    var sizeIdx = shipSizeIndex(root.getAttribute('data-product-id'), root.getAttribute('data-lounge-size'));
    var isMetroOnly = root.getAttribute('data-ship-metro-only') === 'true';
    var METRO_ONLY_ZONES = ['Metro Brisbane', 'Just Out of Metro Brisbane'];
    var METRO_ONLY_FEE = 39;
    var lastPc = '', lastZone = null;
    function goBtn(fee) {
      var v = curVariant(); if (!v) return '';
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var addonCents = addons.reduce(function (sum, a) { return sum + (a.checked ? (parseFloat(a.getAttribute('data-price')) || 0) * 100 : 0); }, 0);
      var total = (v.price + addonCents) * q + fee * 100;
      return '<button type="button" class="sr-go" data-fee="' + fee + '">' + TRUCK_SVG +
        '<span class="sr-go-txt"><strong>Deliver it to my home</strong><small>Checkout · ' + money(total) + ' incl. ' + shipMoney(fee) + ' delivery</small></span>' +
        '<span class="sr-go-arrow" aria-hidden="true">→</span></button>';
    }
    function render(pc, zone) {
      var head = '<div class="sr-head"><span class="sr-where">' + pc + (zone ? '<small>' + zone.name + '</small>' : '') + '</span><button type="button" class="sb-change">Change</button></div>';
      if (isMetroOnly) {
        var inMetroZone = zone && METRO_ONLY_ZONES.indexOf(zone.name) > -1;
        if (!inMetroZone) {
          out.innerHTML = head + '<p class="sr-msg">Delivery isn’t available to this postcode for this item yet. Call <a href="tel:0731904948">(07) 3190 4948</a> for a special request.</p>';
          return;
        }
        out.innerHTML = head + '<div class="sr-grid"><div><span class="sr-lbl">Delivery</span><span class="sr-val">' + shipMoney(METRO_ONLY_FEE) + '</span></div>' +
          '<div><span class="sr-lbl">Arrives by</span><span class="sr-val sr-ok" style="display:inline-flex;align-items:center;gap:5px;">' + SHIELD_SVG + fastDateText + '*</span></div></div>' +
          '<p class="sr-note">*Subject to availability</p>' + goBtn(METRO_ONLY_FEE);
        return;
      }
      if (!zone) {
        out.innerHTML = head + '<p class="sr-msg">We don’t currently deliver to this postcode by our own truck. Local pickup from Rocklea or Enoggera is still free — or call <a href="tel:0731904948">(07) 3190 4948</a> to ask about freight options.</p>';
        return;
      }
      var timeBlock = (shipboxPreorder || zone.confirm)
        ? '<div><span class="sr-lbl">Delivery time</span><span class="sr-val sr-confirm">We’ll confirm</span></div>'
        : '<div><span class="sr-lbl">Arrives by</span><span class="sr-val sr-ok" style="display:inline-flex;align-items:center;gap:5px;">' + SHIELD_SVG + fastDateText + '*</span></div>';
      var noteBlock = shipboxPreorder
        ? '<p class="sr-note">This is a pre-order — we’ll confirm your delivery date once it arrives.</p>'
        : zone.confirm
        ? '<p class="sr-note">3-day delivery isn’t available to this area. We’ll contact you after your order to confirm your delivery date.</p>'
        : '<p class="sr-note">*Subject to availability</p>';
      out.innerHTML = head + '<div class="sr-grid"><div><span class="sr-lbl">Delivery</span><span class="sr-val">' + shipMoney(zone.price[sizeIdx]) + '</span></div>' +
        timeBlock + '</div>' + noteBlock + goBtn(zone.price[sizeIdx]);
    }
    var pcUrl = box.getAttribute('data-afw-pc-url'), pcList = null, pcReq = null, shown = [], activeIdx = -1;
    var sugg = document.createElement('ul');
    sugg.className = 'sb-sugg'; sugg.id = input.id + '-list'; sugg.setAttribute('role', 'listbox'); sugg.hidden = true;
    out.parentNode.insertBefore(sugg, out);
    input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', sugg.id); input.setAttribute('aria-expanded', 'false');
    function loadPc() {
      if (pcList) return Promise.resolve(pcList);
      if (!pcReq) pcReq = fetch(pcUrl).then(function (r) { return r.json(); }).then(function (d) { pcList = d; return d; }).catch(function () { pcReq = null; return []; });
      return pcReq;
    }
    function hideSugg() { sugg.hidden = true; sugg.innerHTML = ''; shown = []; activeIdx = -1; input.setAttribute('aria-expanded', 'false'); }
    function setActive(i) {
      activeIdx = i;
      $$('li', sugg).forEach(function (li, k) { li.classList.toggle('is-active', k === i); li.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function pickSugg(r) {
      input.value = r[0];
      if (stateSel && stateSel.querySelector('option[value="' + r[2] + '"]')) stateSel.value = r[2];
      hideSugg();
      form.requestSubmit();
    }
    function showSugg(q) {
      loadPc().then(function (list) {
        if (input.value.trim() !== q) return;
        var numeric = /^\d+$/.test(q), up = q.toUpperCase(), res = [];
        var stateFilter = stateSel ? stateSel.value : '';
        for (var i = 0; i < list.length; i++) {
          var r = list[i];
          if (stateFilter && r[2] !== stateFilter) continue;
          if (numeric ? r[0].indexOf(q) === 0 : r[1].indexOf(up) === 0) res.push(r);
        }
        if (numeric) res.sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : a[1] < b[1] ? -1 : 1; });
        shown = res.slice(0, 8);
        if (!shown.length) { hideSugg(); return; }
        sugg.innerHTML = shown.map(function (r, i) {
          return '<li role="option" aria-selected="false"><button type="button" class="sb-opt" tabindex="-1" data-i="' + i + '"><strong>' + r[1] + '</strong><span>' + r[2] + ' ' + r[0] + '</span></button></li>';
        }).join('');
        activeIdx = -1; sugg.hidden = false; input.setAttribute('aria-expanded', 'true');
      });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim(), numeric = /^\d+$/.test(q);
      if ((numeric && q.length >= 2) || (!numeric && q.length >= 2 && /^[a-zA-Z][a-zA-Z '\-]*$/.test(q))) showSugg(q);
      else hideSugg();
    });
    input.addEventListener('keydown', function (e) {
      if (sugg.hidden || !shown.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((activeIdx + 1) % shown.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((activeIdx - 1 + shown.length) % shown.length); }
      else if (e.key === 'Enter' && activeIdx > -1) { e.preventDefault(); pickSugg(shown[activeIdx]); }
      else if (e.key === 'Escape') hideSugg();
    });
    sugg.addEventListener('mousedown', function (e) {
      var b = e.target.closest('button[data-i]');
      if (!b) return;
      e.preventDefault();
      pickSugg(shown[parseInt(b.getAttribute('data-i'), 10)]);
    });
    document.addEventListener('click', function (e) { if (!sugg.contains(e.target) && e.target !== input) hideSugg(); });
    function checkPc(pc, state) {
      var sOf = state || stateOfPc(pc);
      if (sOf && stateSel && stateSel.querySelector('option[value="' + sOf + '"]')) stateSel.value = sOf;
      out.hidden = false;
      lastPc = pc; lastZone = findShipZone(pc);
      setAsmRestricted(!lastZone || !!lastZone.confirm);
      render(pc, lastZone);
      form.classList.add('has-result');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideSugg();
      var raw = (input.value || '').trim();
      out.hidden = false;
      if (/^\d{4}$/.test(raw)) { checkPc(raw, null); return; }
      if (!raw || /^\d+$/.test(raw)) { out.innerHTML = '<p class="sr-msg">Enter a 4-digit postcode.</p>'; return; }
      loadPc().then(function (list) {
        var up = raw.toUpperCase();
        var stateFilter = stateSel ? stateSel.value : '';
        var m = list.filter(function (r) { return r[1] === up && (!stateFilter || r[2] === stateFilter); });
        if (m.length) checkPc(m[0][0], m[0][2]);
        else out.innerHTML = '<p class="sr-msg">We couldn’t find that suburb in ' + (stateFilter || 'that state') + '. Pick one from the list or enter a 4-digit postcode.</p>';
      });
    });
    out.addEventListener('click', function (e) {
      if (e.target.closest('.sb-change')) {
        out.hidden = true; out.innerHTML = ''; form.classList.remove('has-result'); input.value = ''; input.focus();
        lastZone = null;
        setAsmRestricted(false);
        return;
      }
      var goBtnEl = e.target.closest('.sr-go');
      if (!goBtnEl) return;
      goBtnEl.disabled = true;
      var v = curVariant(); if (!v) return;
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var items = [{ id: v.id, quantity: q }];
      var shipboxIsPreorder = root.getAttribute('data-is-preorder') === 'true';
      var shipboxPreorderFull = '';
      if (shipboxIsPreorder) {
        var payRadio = root.querySelector('[data-preorder-pay-radio]:checked');
        shipboxPreorderFull = payRadio ? payRadio.value : '';
        items[0].properties = { '_preorder': 'true', 'Pre-order': 'Ships approx ' + (root.getAttribute('data-preorder-eta') || 'TBC - we will confirm') };
        if (shipboxPreorderFull) items[0].properties['_preorder_full'] = shipboxPreorderFull;
      }
      addons.forEach(function (a) {
        if (!a.checked) return;
        var props = { '_Added from': window.location.pathname };
        if (shipboxIsPreorder) {
          props['_preorder'] = 'true'; // so the deposit discount also covers add-ons, not just the lounge
          if (shipboxPreorderFull) props['_preorder_full'] = shipboxPreorderFull;
        }
        items.push({ id: Number(a.value), quantity: 1, properties: props });
      });
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
        .then(function () { window.location.href = (window.routes && window.routes.checkout_url) || '/checkout'; })
        .catch(function () { goBtnEl.disabled = false; alert('Sorry, that could not be added. Please try again.'); });
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var dataEl = $('[data-afw-product-json]', root);
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var stockEl = $('[data-afw-stock-json]', root);
    var stock = stockEl ? JSON.parse(stockEl.textContent) : {};
    var currency = root.getAttribute('data-currency') || 'AUD';
    var threshold = parseInt(root.getAttribute('data-stock-threshold'), 10) || 5;
    var isPreorder = root.getAttribute('data-is-preorder') === 'true';
    function money(cents, noZeros) {
      var v = cents / 100;
      var opts = { style: 'currency', currency: currency };
      if (noZeros && v % 1 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
      return v.toLocaleString('en-AU', opts);
    }

    /* Gallery */
    var gallery = $('.gallery-main', root);
    var items = $$('.afw-media-item', root);
    var thumbs = $$('.afw-thumb', root);
    var current = 0;
    function show(i) {
      if (!items.length) return;
      current = (i + items.length) % items.length;
      items.forEach(function (it, k) {
        var on = k === current; it.hidden = !on;
        if (!on) { var v = it.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
      var isVideo = items[current].getAttribute('data-type') !== 'image';
      gallery.classList.toggle('is-video', isVideo);
      if (isVideo) gallery.classList.remove('is-zooming');
      var a = thumbs[current];
      if (a && a.scrollIntoView && a.parentNode.scrollWidth > a.parentNode.clientWidth) a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = $('[data-afw-gal-prev]', root), next = $('[data-afw-gal-next]', root);
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    if (items.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }

    /* Hover zoom (mouse only, images only) */
    if (gallery && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      gallery.addEventListener('mousemove', function (e) {
        var it = items[current]; if (!it || it.getAttribute('data-type') !== 'image') return;
        var over = !e.target.closest('.gal-arrow');
        gallery.classList.toggle('is-zooming', over);
        var r = gallery.getBoundingClientRect(), img = it.querySelector('img');
        if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      gallery.addEventListener('mouseleave', function () { gallery.classList.remove('is-zooming'); });
    }

    /* Quantity */
    var qty = $('[data-afw-qty]', root);
    if (qty) {
      $('[data-afw-qty-minus]', root).addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      $('[data-afw-qty-plus]', root).addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* Stock bar */
    function renderStock(variantId) {
      var box = $('[data-afw-stock]', root); if (!box) return;
      var q = stock[String(variantId)];
      if (typeof q === 'number' && q > 0 && q < threshold) {
        box.hidden = false;
        $('[data-afw-stock-count]', box).textContent = q;
        var fill = $('[data-afw-stock-fill]', box);
        fill.style.width = '0%';
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = (q / threshold * 100) + '%'; }); });
      } else { box.hidden = true; }
    }

    /* Description read-more */
    var descBody = $('[data-afw-desc-body]', root), descToggle = $('[data-afw-desc-toggle]', root);
    if (descBody && descToggle && descBody.scrollHeight > 260) {
      descBody.classList.add('is-clamped'); descToggle.hidden = false;
      descToggle.addEventListener('click', function () {
        var open = descBody.classList.toggle('is-clamped') === false;
        descToggle.textContent = open ? 'Show less' : 'Read more';
      });
    }

    /* Variants */
    var idInput = $('[data-afw-variant-id]', root);
    var pills = $$('[data-afw-option]', root);
    function selectedOptions() {
      var groups = {};
      pills.forEach(function (p) { if (p.getAttribute('aria-pressed') === 'true') groups[p.getAttribute('data-afw-option')] = p.getAttribute('data-value'); });
      return groups;
    }
    function findVariant() {
      if (!product) return null;
      var sel = selectedOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === undefined || sel[i] === o; });
      }) || null;
    }
    function updateVariant(v) {
      var btn = $('[data-afw-add]', root), label = $('[data-afw-add-label]', root);
      if (!v) { if (btn) btn.disabled = true; if (label) label.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      // disabled follows Shopify's own availability, full stop - no pre-order override. That's
      // what lets a capped pre-order (real on-hand count, "continue selling" left off) actually
      // sell out once the incoming quantity is gone, instead of allowing unlimited oversold orders.
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? (isPreorder ? 'Pre-order' : 'Add to cart') : 'Sold out';
      var priceEl = $('[data-afw-price]', root); if (priceEl) priceEl.textContent = money(v.price);
      var wasEl = $('[data-afw-was]', root), saveWrap = $('[data-afw-save-wrap]', root), saveEl = $('[data-afw-save]', root);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl) { wasEl.hidden = !onSale; if (onSale) wasEl.textContent = money(v.compare_at_price); }
      if (saveWrap) saveWrap.hidden = !onSale;
      if (saveEl && onSale) {
        var diff = v.compare_at_price - v.price;
        saveEl.textContent = 'Save ' + money(diff, true) + ' (' + Math.round(diff * 100 / v.compare_at_price) + '%)';
      }
      $$('[data-afw-option-value]', root).forEach(function (s) {
        var i = parseInt(s.getAttribute('data-afw-option-value'), 10); s.textContent = v.options[i];
      });
      if (v.featured_media) {
        var idx = items.findIndex(function (it) { return it.getAttribute('data-media-id') === String(v.featured_media.id); });
        if (idx > -1) show(idx);
      }
      renderStock(v.id);
      if (window.history && window.history.replaceState && product.variants.length > 1) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var g = p.getAttribute('data-afw-option');
        pills.forEach(function (q) { if (q.getAttribute('data-afw-option') === g) q.setAttribute('aria-pressed', 'false'); });
        p.setAttribute('aria-pressed', 'true');
        updateVariant(findVariant());
      });
    });
    if (idInput) renderStock(idInput.value);

    /* Add-ons (assembly, protection, etc): add the lounge plus every checked add-on in one request */
    var form = $('form[action*="/cart/add"]', root), addons = $$('[data-afw-addon]', root);
    if (form && addons.length) {
      form.addEventListener('submit', function (e) {
        var checked = addons.filter(function (a) { return a.checked; });
        if (!checked.length) return;
        e.preventDefault();
        var fd = new FormData(form);
        var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
        var preorderFlag = fd.get('properties[_preorder]');
        var preorderFullFlag = fd.get('properties[_preorder_full]');
        if (preorderFlag) {
          items[0].properties = { '_preorder': preorderFlag, 'Pre-order': fd.get('properties[Pre-order]') || '' };
          if (preorderFullFlag) items[0].properties['_preorder_full'] = preorderFullFlag;
        }
        checked.forEach(function (a) {
          var props = { '_Added from': window.location.pathname };
          if (preorderFlag) {
            props['_preorder'] = preorderFlag; // so the deposit discount also covers add-ons, not just the lounge
            if (preorderFullFlag) props['_preorder_full'] = preorderFullFlag;
          }
          items.push({ id: Number(a.value), quantity: 1, properties: props });
        });
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
          .then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .catch(function () { alert('Sorry, one of your add-ons could not be added. Please try again.'); });
      });
    }
    /* Guard-card add-ons: highlight the card when its checkbox is checked */
    $$('[data-guard-opt]', root).forEach(function (opt) {
      var input = opt.querySelector('input[type="checkbox"]');
      if (!input) return;
      var sync = function () { opt.classList.toggle('is-on', input.checked); };
      input.addEventListener('change', sync); sync();
    });

    /* Pre-order deposit vs pay-in-full toggle */
    var payOpts = $$('[data-preorder-pay-opt]', root);
    if (payOpts.length) {
      var noteDeposit = $('[data-preorder-note-deposit]', root), noteFull = $('[data-preorder-note-full]', root);
      var syncPayChoice = function () {
        var full = false;
        payOpts.forEach(function (opt) {
          var radio = opt.querySelector('[data-preorder-pay-radio]');
          var on = !!(radio && radio.checked);
          opt.classList.toggle('is-active', on);
          if (on && radio.value === 'true') full = true;
        });
        if (noteDeposit) noteDeposit.hidden = full;
        if (noteFull) noteFull.hidden = !full;
      };
      payOpts.forEach(function (opt) {
        var radio = opt.querySelector('[data-preorder-pay-radio]');
        if (radio) radio.addEventListener('change', syncPayChoice);
      });
      syncPayChoice();
    }

    initShipbox(root);

    /* Sticky gallery: stays in normal flow until scrolling would push it off-screen
       (i.e. past the bottom of the video), only then does it lock in place. */
    (function () {
      var col = $('.gallery-col', root); if (!col) return;
      var headH = function () { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--afw-top-h')) || 164; };
      function setTop() {
        var room = window.innerHeight - col.getBoundingClientRect().height - 16;
        col.style.setProperty('--gal-top', Math.min(headH() + 16, room) + 'px');
      }
      window.addEventListener('resize', setTop);
      window.addEventListener('load', setTop);
      setTop();
    })();

    /* Tabs */
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = !on;
        });
      });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab), n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); n.click(); n.focus(); }
      });
    });

  }

  /* ---------- Reviews: read more, lightbox, carousel (lives in the "you may also like" section, not the product form) ---------- */
  function initReviews() {
    /* Review "read more" + photo lightbox */
    $$('.rv-card').forEach(function (card) {
      if (card._afwInit) return; card._afwInit = true;
      var txt = $('.rv-text', card), more = $('.rv-more', card);
      if (txt && more && txt.scrollHeight > txt.clientHeight + 2) {
        more.hidden = false;
        more.addEventListener('click', function () { var o = card.classList.toggle('is-open'); more.textContent = o ? 'Show less' : 'Read more'; });
      }
    });

    var lb = $('[data-afw-lightbox]'); if (lb && lb._afwInit) { lb = null; } else if (lb) { lb._afwInit = true; }
    var lbLast;
    function closeLb() { lb.classList.remove('is-open'); setTimeout(function () { lb.hidden = true; }, 200); if (lbLast) lbLast.focus(); }
    if (lb) {
      $$('[data-afw-photo]').forEach(function (b) {
        b.addEventListener('click', function () {
          lbLast = b; $('img', lb).src = b.getAttribute('data-afw-photo'); $('img', lb).alt = b.getAttribute('data-alt') || '';
          $('figcaption', lb).textContent = b.getAttribute('data-caption') || '';
          lb.hidden = false; requestAnimationFrame(function () { lb.classList.add('is-open'); }); $('.lb-close', lb).focus();
        });
      });
      lb.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
    }

    /* Review carousel */
    var track = $('.rv-list'); if (track && track._afwInit) return; if (track) track._afwInit = true;
    if (track) {
      var rPrev = $('[data-afw-rv-prev]'), rNext = $('[data-afw-rv-next]'), dots = $('[data-afw-rv-dots]');
      var per = function () { return parseInt(getComputedStyle(track).getPropertyValue('--per'), 10) || 1; };
      var pages = function () { return Math.max(1, Math.ceil(track.children.length / per())); };
      var step = function () { return track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0); };
      var atEnd = function () { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; };
      var page = function () { return atEnd() ? pages() - 1 : Math.round(track.scrollLeft / step()); };
      var go = function (p) { p = Math.max(0, Math.min(pages() - 1, p)); track.scrollTo({ left: p * step(), behavior: reduced ? 'auto' : 'smooth' }); };
      var update = function () {
        var p = page(), n = pages();
        rPrev.disabled = track.scrollLeft <= 2; rNext.disabled = atEnd() || n <= 1;
        $$('.rv-dot', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === p); });
        var nav = rPrev.parentNode; nav.hidden = n <= 1;
      };
      var build = function () {
        dots.innerHTML = '';
        for (var i = 0; i < pages(); i++) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'rv-dot'; d.setAttribute('aria-label', 'Show reviews page ' + (i + 1));
          (function (i) { d.addEventListener('click', function () { go(i); }); })(i);
          dots.appendChild(d);
        }
        update();
      };
      rPrev.addEventListener('click', function () { go(page() - 1); });
      rNext.addEventListener('click', function () { go(page() + 1); });
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(update, 60); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });
      build();
    }
  }

  /* ---------- Related products (Shopify recommendations) ---------- */
  function initRelated() {
    $$('[data-afw-related]').forEach(function (el) {
      var url = el.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-afw-related]');
        if (fresh && fresh.querySelector('.rp-card')) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
      }).catch(function () {});
    });
  }

  function syncAnnHeight() {
    var a = document.getElementById('shopify-section-afw-announcement');
    document.documentElement.style.setProperty('--afw-ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  function init() {
    initCountdowns(); syncAnnHeight(); setInterval(syncAnnHeight, 5000); window.addEventListener('resize', syncAnnHeight); initHeader(); initRelated(); initReviews();
    $$('[data-afw-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
